import moment from 'moment';

const parseDate = date => ({
  hour: moment(date).hour(),
  minute: moment(date).minute(),
  day: moment(date).date(),
  month: moment(date).month(),
  year: moment(date).year(),
});

const getSessionTitle = ({ trainingModuleName, trainingModuleCode, trainingPartCode }) => {
  const moduleLabel = trainingModuleName || trainingModuleCode || '';
  const partLabel = trainingPartCode || '';

  return [moduleLabel, partLabel].filter(Boolean).join(' · ');
};

const isValidDateTime = (date, time) => {
  if (!date || !time) {
    return false;
  }

  return (
    moment(date, ['YYYY-MM-DD', 'DD.MM.YYYY', moment.ISO_8601], true).isValid() &&
    moment(`${date} ${time}`, ['YYYY-MM-DD HH:mm', 'DD.MM.YYYY HH:mm', moment.ISO_8601], true).isValid()
  );
};

const createDateWithTime = (date, time) => {
  if (!isValidDateTime(date, time)) {
    return null;
  }

  const { hour, minute } = parseDate(`${date} ${time}`);
  const { year, month, day } = parseDate(date);

  return moment().year(year).month(month).date(day).hour(hour).minute(minute).second(0).millisecond(0).toDate();
};

const transformToSchedulerData = data => {
  return !Array.isArray(data)
    ? []
    : data.reduce((result, item) => {
        const { startTime, endTime, startDate, endDate, deliveryMethod, id, description } = item;
        const title = getSessionTitle(item);
        const start = createDateWithTime(startDate, startTime);
        const end = createDateWithTime(endDate, endTime);

        if (!start || !end) {
          return result;
        }

        result.push({
          id,
          type: deliveryMethod,
          start,
          end,
          desc: description,
          title,
          sessionInfo: item,
        });

        return result;
      }, []);
};

export default transformToSchedulerData;
